import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
// import { message } from 'antd'
// import { client } from '@utils/client'
// import { useHistory } from 'react-router-dom'
import Modal from '@components/Modal'
import CloseSvg from '@image/icons/CloseSvg'
import {
  wellKidzClubButton,
  wellKidzClubError,
  wellKidzClubMember,
} from './List'
import Text from '@components/Text'
import { ThemeContext } from '@contexts/ThemeContext'
import { Alert, Button, Form, message, Upload } from 'antd'
import { ExcelToJSON } from '@utils/excel'
import _ from 'lodash'
import { PlusCircleOutlined } from '@ant-design/icons'
import { client } from '@utils/client'
const AddMember = (props) => {
  const { open, setOpen } = props
  const { t } = useLocalization()
  const { theme } = useContext(ThemeContext)
  const [fileName, setFileName] = useState('')
  const [payload, setPayload] = useState([])
  const [errorMessage, setErrorMessage] = useState()
  const [fileList, setFileList] = useState([])
  const [form] = Form.useForm()

  // const history = useHistory()
  // const params = useParams()

  const handleSubmit = async () => {
    if (!_.isEmpty(errorMessage)) return
    try {
      await client.post(`/wellkidzclub/user/admin`, { users: payload })
      message.success('สำเร็จ')
      setOpen(false)
    } catch (e) {
      if (e.response) setErrorMessage(e.response.data.message)
      message.error('ไม่สำเร็จ')
    }
  }

  /**
   * @type {{
   * footer: React.CSSProperties
   * body: React.CSSProperties
   * header: React.CSSProperties
   * bodyModalStyle: React.CSSProperties
   * btn: React.CSSProperties
   * btnAdd: React.CSSProperties
   * listfile: React.CSSProperties
   * }}
   */

  const style = {
    header: {},
    body: { display: 'flex', flexDirection: 'column', gap: 16 },
    bodyModalStyle: {
      display: 'flex',
      flexDirection: 'column',
      padding: 16,
      overflowY: 'hidden',
      gap: 16,
      maxHeight: 700,
    },
    footer: {
      display: 'flex',
      justifyContent: 'center',
      paddingBottom: 6,
      gap: 8,
    },

    btn: {
      borderRadius: '8px',
      width: 'max-content',
      height: '40px',
    },
    btnAdd: {
      borderRadius: '8px',
      width: '230px',
      height: '40px',
    },
    listfile: {
      display: 'flex',
      padding: '0px 8px',
      border: `1px solid ${theme.grey}`,
      borderRadius: 16,
      width: 'max-content',
      alignItems: 'center',
      backgroundColor: theme.whiteGrey,
      gap: 8,
    },
  }

  const actions = {
    setPayload: (list) => {
      if (_.isEmpty(list)) {
        setErrorMessage('ไม่พบข้อมูลไฟล์')
      }
      const result = transformMemberData(list)
      setPayload(result)
    },
  }
  const customRequest = ({ file, onSuccess }) => {
    const xl2json = new ExcelToJSON(actions)
    xl2json.parseExcel(file)
    setFileName(file.name)
    setFileList([file])
    setTimeout(() => {
      onSuccess('ok')
    }, 0)
  }

  const transformMemberData = (data) => {
    return data.map((member) => ({
      hn: member['Hospital Number สมาชิก'],
      citizenId: member['Citizen ID สมาชิก'] || '',
      passportId: member['passportId สมาชิก'] || '',
    }))
  }

  const reset = () => {
    form.resetFields()
    setFileName('')
    setPayload(null)
    setFileList([])
    setErrorMessage(undefined)
  }
  return (
    <>
      <Modal
        // title={`${firstname} ${lastname}`}
        centered={false}
        open={open}
        onCancel={() => setOpen(false)}
        closable={true}
        maskClosable={false}
        // footer={null}
        width={500}
        // style={{ top: 20 }}
        bodyStyle={style.bodyModalStyle}
      >
        <div style={style.header}>
          <Text level={1} strong>
            {t(`${wellKidzClubMember}.addMemberViaFile`)}
          </Text>
        </div>
        {errorMessage && (
          <Alert
            message={errorMessage}
            type="error"
            showIcon
            closable
            onClose={reset}
          />
        )}
        <div style={style.body}>
          <Text level={3}>{t(`${wellKidzClubMember}.uploadFile`)}</Text>
          {fileName && (
            <div style={style.listfile}>
              {fileName}
              <span style={{ cursor: 'pointer' }} onClick={reset}>
                <CloseSvg color={'#8A8A8AD9'} />
              </span>
            </div>
          )}
          <Form
            layout="vertical"
            form={form}
            name="control-hooks"
            onFinish={handleSubmit}
            requiredMark={false}
          >
            <Form.Item
              name="uploadFile"
              // label="uploadFile"
              rules={[
                {
                  required: true,
                  message: `${t(`${wellKidzClubError}.please`)}${t(
                    `${wellKidzClubMember}.uploadFile`
                  )}`,
                },
              ]}
            >
              <Upload
                accept=".xlsx"
                customRequest={customRequest}
                showUploadList={false}
                fileList={fileList}
              >
                <Button
                  type={'primary'}
                  disabled={!_.isEmpty(payload)}
                  style={style.btn}
                  icon={
                    <PlusCircleOutlined
                      style={{
                        fontSize: 18,
                      }}
                    />
                  }
                >
                  {t(`${wellKidzClubButton}.uploadFile`)}
                </Button>
              </Upload>
            </Form.Item>
          </Form>
        </div>
        <div style={style.footer}>
          <Button
            type={'primary'}
            key="addDataMamber"
            onClick={() => form.submit()}
            style={style.btnAdd}
          >
            <Text level={3} color={theme.text.white} strong>
              {t(`${wellKidzClubButton}.addData`)}
            </Text>
          </Button>
        </div>
      </Modal>
    </>
  )
}

AddMember.propTypes = {
  setOpen: PropTypes.func,
  open: PropTypes.bool,
}

export default AddMember
